import { useEffect, useRef } from "react";
import { useThree } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import * as THREE from "three";

import { DEFAULT_ENGINE_CONFIG } from "@/types/engine.types";

export function IsometricCamera() {
  const controlsRef = useRef<React.ComponentRef<typeof OrbitControls>>(null);
  const { camera } = useThree();

  useEffect(() => {
    const { cameraDefaultDistance, cameraDefaultPolar, cameraDefaultAzimuth } =
      DEFAULT_ENGINE_CONFIG;
    const x =
      cameraDefaultDistance *
      Math.sin(cameraDefaultPolar) *
      Math.sin(cameraDefaultAzimuth);
    const y = cameraDefaultDistance * Math.cos(cameraDefaultPolar);
    const z =
      cameraDefaultDistance *
      Math.sin(cameraDefaultPolar) *
      Math.cos(cameraDefaultAzimuth);
    camera.position.set(x, y, z);
    camera.lookAt(0, 0, 0);
  }, [camera]);

  return (
    <OrbitControls
      ref={controlsRef}
      makeDefault
      mouseButtons={{
        LEFT: THREE.MOUSE.ROTATE,
        MIDDLE: THREE.MOUSE.DOLLY,
        RIGHT: THREE.MOUSE.PAN,
      }}
      minDistance={DEFAULT_ENGINE_CONFIG.cameraMinDistance}
      maxDistance={DEFAULT_ENGINE_CONFIG.cameraMaxDistance}
      minPolarAngle={0.2}
      maxPolarAngle={Math.PI / 2.5}
    />
  );
}
